import * as React from 'react';

import { enumSalesLoadLineItemPhase } from '@rematter/frontend-lib-api-client';
import { $lineItemsByPhaseKey } from '@rematter/modules/trade/_state/loadForm.state';
import { useAtomValue } from 'jotai';

export const useLoadStagedData = () => {
  const lineItemsByPhaseKey = useAtomValue($lineItemsByPhaseKey);

  const stagedLineItems = React.useMemo(
    () => lineItemsByPhaseKey[enumSalesLoadLineItemPhase.Staged],
    [lineItemsByPhaseKey],
  );

  const requestedLineItems = React.useMemo(
    () => lineItemsByPhaseKey[enumSalesLoadLineItemPhase.Requested],
    [lineItemsByPhaseKey],
  );

  const stagedPhase = enumSalesLoadLineItemPhase.Staged;

  return { stagedLineItems, requestedLineItems, stagedPhase };
};
